import { ControlsButton } from '../../../../../_components/ControlsButton'
import React from 'react'
import { useModal } from '../../../../../_reduxHooks/modal.hook'
import ConfirmDeleteModal from './ConfirmDeleteModal'

export const RemoveScheduleInvoice = ({ entity, onRemove, isDisabled }) => {
  const { openModal, closeModal } = useModal()
  const onClick = () => {
    openModal(ConfirmDeleteModal, { invoice: entity, closeModal, onRemove })
  }
  return <ControlsButton icon="close" isDisabled={isDisabled} onClick={onClick} />
}
